<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb
      activeName="订单预约管理"
      :breadcrumbItem="[{ to: '/orders/list', name: '订单列表' }]"
    ></breadcrumb>

    <!-- begin page-header -->
    <h1 class="page-header">
      预约管理
      <small>用户预约管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="用户预约列表">
      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.goods_name" placeholder="商品名称"></Input>
        </Col>
        <Col span="3">
          <Input v-model="filterCond.mobile" placeholder="手机号码"></Input>
        </Col>
        <Col span="3">
          <Input v-model="filterCond.username" placeholder="姓名"></Input>
        </Col>
        <Col span="4">
          <DatePicker
            v-model="orderdate"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="评价日期"
            style="width: 100%"
          ></DatePicker>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.status" placeholder="状态">
            <Option :value="99">不限制</Option>
            <Option :value="0">未确认</Option>
            <Option :value="1">已确认</Option>
            <Option :value="2">报告已上传</Option>
            <Option :value="-1">取消</Option>
          </Select>
        </Col>

        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query"
            >查询</Button
          >
        </Col>
      </Row>
      <Table class="m-t-10" :columns="columns" :data="datas">
        <template slot="order_sn" slot-scope="{ row }">{{
          row.order.order_sn
        }}</template>
        <template slot="ordergoods" slot-scope="{ row }">
          <p v-for="(item, index) in row.order.ordergoods" :key="index">
            {{ item.goods_name }} {{ item.goods_number }} * ￥{{
              item.promotion_price
            }}
          </p>
        </template>
        <template slot="goods_name" slot-scope="{ row }">{{
          row.ordergoods[0].goods_name
        }}</template>

        <template slot="idcard" slot-scope="{ row }">{{
          idCardFormat(row.idcard, 3, 3)
        }}</template>
        <template slot="reportfile" slot-scope="{ row }">
          <a
            target="_blank"
            :href="logourl + row.reportfile"
            v-if="row.status == 2"
            >报告</a
          >
        </template>
        <template slot="status" slot-scope="{ row }">
          <span v-if="row.status == 0">未确认</span>
          <span v-else-if="row.status == 1" style="color:green">已完成</span>
          <span v-else-if="row.status == -1" style="color:red">取消</span>
          <span v-else-if="row.status == 2" style="color:green"
            >报告已上传</span
          >
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <button
            v-if="row.status == 0"
            type="button"
            class="btn btn-theme m-r-10"
            @click="fn_confirm_appointment(row, 1)"
          >
            到场确认
          </button>
          <button
            type="button"
            class="btn btn-theme m-r-10"
            @click="fn_show_member(row, 1)"
          >
            会员
          </button>
          <button
            type="button"
            class="btn btn-theme m-r-10"
            v-if="row.status == 1 || row.status == 2"
            @click="fn_upload_document(row, index)"
          >
            上传报告
          </button>
          <button
            type="button"
            class="btn btn-danger"
            v-if="row.status == 0"
            @click="fn_confirm_appointment(row, -1)"
          >
            取消
          </button>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="filterCond.page"
        :page-size="filterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer
      title="上传体检报告"
      :closable="true"
      width="512"
      v-model="v_upload_document"
    >
      <Upload
        name="filename"
        :show-upload-list="true"
        :action="uploadhost"
        :format="['pdf']"
        :on-success="fn_uploadSuccess"
        :max-size="4096"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        style="display: inline-block;"
      >
        <Button icon="ios-cloud-upload-outline" class="btn btn-theme"
          >上传报告</Button
        >
      </Upload>
    </Drawer>
    <Modal v-model="v_pay_user" title="付款人信息">
      <p>{{ payUser.name }}</p>
      <p>{{ payUser.realname }}</p>
      <p v-if="payUser.idcard">{{ idCardFormat(payUser.idcard, 3, 4) }}</p>
      <p>{{ payUser.mobile }}</p>
    </Modal>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import {
  getAppointmentList,
  confirmAppointment,
  storeAppointmentReportFile
} from "@/api/order";

import config from "@/config";
import moment from "moment";
export default {
  components: { breadcrumb },
  data() {
    return {
      v_pay_user: false,
      v_upload_document: false,
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      orderdate: [],
      filterCond: {
        begindate: "",
        enddate: "",
        goods_name: "",
        username: "",
        mobile: "",
        status: 99,
        page: 1,
        pageNum: 10
      },
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "姓名",
          key: "username",
          width: 150
        },
        {
          title: "手机号码",
          key: "mobile",
          width: 120
        },
        {
          title: "身份证",
          slot: "idcard",
          width: 200
        },
        {
          title: "商品名称",
          slot: "goods_name",
          width: 250
        },
        {
          title: "预约时间",
          key: "appointment"
        },
        {
          title: "创建时间",
          key: "created_at",
          width: 150
        },
        {
          title: "状态",
          slot: "status",
          width: 100
        },
        {
          title: "报告",
          slot: "reportfile",
          width: 100
        },
        {
          title: "操作",
          slot: "action",
          width: 250
        }
      ],
      datas: [],
      totalRows: 0,

      //上传报告的内容
      formData: {
        id: 0,
        reportfile: ""
      },
      rowIndex: 0,
      payUser: {}
    };
  },
  mounted() {
    this.fn_load(this.filterCond);
  },
  methods: {
    fn_show_member(row) {
      this.v_pay_user = true;
      this.payUser = row.users;
    },
    idCardFormat(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = "";
      for (var i = 0; i < len; i++) {
        xing += "*";
      }
      return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      );
    },
    fn_upload_document(row, index) {
      //上传体检报告
      this.formData.id = row.id;
      this.rowIndex = index;
      this.v_upload_document = true;
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.reportfile = file.response.data;
        storeAppointmentReportFile(this.formData)
          .then(res => {
            if (res.data.code === 200) {
              this.datas[this.rowIndex].reportfile = this.formData.reportfile;
              this.$Notice.success(res.data);
              this.v_upload_document = false;
            } else {
              this.$Notice.error(res.data);
            }
          })
          .catch(error => {
            this.$Message.error(error);
          });
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 4M。"
      });
    },

    idCardFormat(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = "";
      for (var i = 0; i < len; i++) {
        xing += "*";
      }
      return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      );
    },
    fn_confirm_appointment(row, status) {
      confirmAppointment({ id: row.id, status })
        .then(res => {
          if (res.data.code === 200) {
            row.status = status;
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
      //   console.log(row);
    },
    fn_query() {
      this.filterCond.page = 1;
      this.fn_load(this.filterCond);
    },
    fn_load(filterCond) {
      if (this.orderdate.length > 0) {
        this.filterCond.begindate = moment(this.orderdate[0]).format(
          "YYYY-MM-DD"
        );
        this.filterCond.enddate = moment(this.orderdate[1]).format(
          "YYYY-MM-DD"
        );
      } else {
        this.filterCond.begindate = "";
        this.filterCond.enddate = "";
      }
      getAppointmentList(filterCond)
        .then(res => {
          this.datas = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_load(this.filterCond);
    }
  }
};
</script>
